<template>
  <ModalLoginOffres v-if="showModallogin" @showSignup="showSignup" @close="setUser"></ModalLoginOffres>
  <div v-else id="modal-signup-offres">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div
            class="modal-content"
            role="dialog"
            aria-labelledby="modalTitle"
            aria-describedby="modalDescription"
          >
            <div class="modal-content-form">
              <div class="header-modal">
                <slot name="header">
                  <h1 :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">Ne manquez pas nos offres exclusives !</h1>
                </slot>
              </div>
              <div class="d-flex align-items-start pt-3" :class="isPhone ? 'flex-column' : ''">
                <img v-if="!isPhone" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/GIF+-+Page+offres+exclusives+-+Pop-up.gif" v-set-alt class="img-form-signup">
                <div class="form-signup raleway-reg-p15" :class="isPhone ? 'pt-3' : 'pl-5'">
                  <p class="raleway-reg-p15 text-center mb-0">Créez votre compte en quelques secondes et accédez à des tarifs privilégiés et des avantages réservés à nos membres. Un monde de privilèges vous attend.</p>
                  <div class="form-item">
                    <label for="first_name">Prénom</label>
                    <input v-model="userInfo.first_name" type="text" />
                  </div>
                  <div class="form-item">
                    <label for="last_name">Nom</label>
                    <input v-model="userInfo.last_name" type="text" />
                  </div>
                  <div class="form-item">
                    <label for="email">E-mail</label>
                    <input v-model="userInfo.email" type="text"  />
                  </div>
                  <div class="form-item">
                    <label for="password">Mot de passe</label>
                    <input v-model="userInfo.password" type="password" />
                  </div>
                  <div>
                    <p  class="mb-0" style="color: red">{{ this.text }}</p>
                  </div>
                </div>
              </div>
              <div class="form-check raleway-reg-p15">
                <button @click="UserBasicInfo" class="hortense-btn-primary">
                  CRÉER UN COMPTE
                </button>
              </div>
              <div class="d-flex justify-content-center pt-2">
                <p class="raleway-reg-p15 mb-0">Vous avez déjà un compte ?</p>
                <a class="link-hortense ml-1" @click="showModallogin = true">Connectez-vous</a>
              </div>
              <div class="d-flex justify-content-center align-items-center pt-1" @click="redirectTo('/')">
                <i class="fa-solid fa-house ml-2" style="color: #3B6152;"></i>
                <span class="raleway-reg-p15 ml-2 link-hortense cursor-pointer">Retour à la page d'accueil</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import fetcher from "packs/shared/api.js";
import ModalLoginOffres from "./ModalLoginOffres.vue";

export default {
  name: "modal-signup-offres",
  components: { ModalLoginOffres },
  props: { showModalLogin: Boolean },
  data() {
    return {
      userInfo: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        newsletter: false,
      },
      checkedItems: [],
      showModal: false,
      showModallogin: this.showModalLogin,
      status: null,
      text: null,
      isPhone: window.innerWidth <= 768,
    };
  },
  beforeDestroy() {
    const whatsappBtn = document.getElementById('whatsapp-button');
    if (whatsappBtn) {
      whatsappBtn.style.display = 'block';
    }
    document.querySelectorAll('.fixed-banner').forEach(el => {
      el.style.zIndex = '';
    });
    document.querySelectorAll('.fixed-bannertwo').forEach(el => {
      el.style.zIndex = '';
    });
    if (this.isPhone) {
      document.body.style.overflow = '';
    }
  },
  mounted() {
    const whatsappBtn = document.getElementById('whatsapp-button');
    if (whatsappBtn) {
      whatsappBtn.style.display = 'none';
    }
    document.querySelectorAll('.fixed-banner').forEach(el => {
      el.style.zIndex = '1';
    });
    document.querySelectorAll('.fixed-bannertwo').forEach(el => {
      el.style.zIndex = '1';
    });
    if (this.isPhone) {
      document.body.style.overflow = 'hidden';
    }
  },
  methods: {
    pushLoginEvent(method) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'sign_up',
        method: method,
      });
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    async UserBasicInfo() {
      if (!this.userInfo.first_name || !this.userInfo.last_name) {
        this.text = "Le prénom et le nom sont requis";
        return;
      }
      if (!this.validateEmail(this.userInfo.email)) {
        this.text = "Email incorrect";
        return;
      }
      if (this.userInfo.password.length < 12) {
        this.text = "Le mot de passe doit contenir au moins 12 caractères";
        return;
      }

      if (this.checkedItems.includes("newsletter")) {
        this.userInfo.newsletter = true;
      }

      try {
        const response = await fetcher.post("/users/", {
          user: {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            email: this.userInfo.email,
            password: this.userInfo.password,
            newsletter: this.userInfo.newsletter,
          },
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_up',
          method: 'email_password',
        });
        if (!response.error){
          this.$emit("close", response.data);
          location.reload();
        }
      } catch (e) {
        console.log(e);
        
        if (e.response && e.response.data) {
          if (e.response.data.errors) {
            if (typeof e.response.data.errors === 'object') {
              const errorMessages = [];
              for (const [field, messages] of Object.entries(e.response.data.errors)) {
                if (Array.isArray(messages)) {
                  errorMessages.push(...messages.map(msg => this.translateErrorMessage(field, msg)));
                } else {
                  errorMessages.push(this.translateErrorMessage(field, messages));
                }
              }
              this.text = errorMessages[0];
            } else if (Array.isArray(e.response.data.errors)) {
              this.text = e.response.data.errors.map(msg => this.translateErrorMessage('', msg))[0];
            } else {
              this.text = this.translateErrorMessage('', e.response.data.errors);
            }
          } else if (e.response.data.error) {
            this.text = this.translateErrorMessage('', e.response.data.error);
          } else if (e.response.data.message) {
            this.text = this.translateErrorMessage('', e.response.data.message);
          } else {
            switch (e.response.status) {
              case 422:
                this.text = "Les données saisies ne sont pas valides";
                break;
              case 409:
                this.text = "Cet email est déjà utilisé";
                break;
              case 500:
                this.text = "Erreur serveur, veuillez réessayer plus tard";
                break;
              default:
                this.text = "Une erreur est survenue lors de l'inscription";
            }
          }
        } else {
          this.text = "Impossible de terminer l'inscription. Vérifiez que vos informations sont correctes et réessayez.";
        }
      }
    },
    translateErrorMessage(field, message) {
      const translations = {
        'has already been taken': 'est déjà utilisé',
        'is too short': 'est trop court',
        'is too long': 'est trop long',
        'is invalid': 'est invalide',
        'can\'t be blank': 'ne peut pas être vide',
        'doesn\'t match': 'ne correspond pas',
        'must be accepted': 'doit être accepté',
        'is not included in the list': 'n\'est pas inclus dans la liste',
        'must be greater than': 'doit être supérieur à',
        'must be less than': 'doit être inférieur à',
        'must be equal to': 'doit être égal à',
        'must be confirmed': 'doit être confirmé',
        'is not a number': 'n\'est pas un nombre',
        'is reserved': 'est réservé'
      };

      const fieldTranslations = {
        'email': 'L\'email',
        'password': 'Le mot de passe',
        'first_name': 'Le prénom',
        'last_name': 'Le nom'
      };

      let translatedMessage = message;
      for (const [english, french] of Object.entries(translations)) {
        if (message.includes(english)) {
          translatedMessage = message.replace(english, french);
          break;
        }
      }

      if (field && fieldTranslations[field]) {
        return `${fieldTranslations[field]} ${translatedMessage}`;
      }

      return translatedMessage;
    },
    setUser(user) {
      this.user = user;
      this.showModal = false;
      this.showModallogin = false;
      this.$emit("close", user);
    },
    redirectTo(path) {
      window.location.href = path;
    },
    showSignup() {
      this.showModallogin = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content-form {
  padding: 35px 75px;
  overflow-y: scroll;
  height: auto;
  max-height: 87vh;
  
  @media screen and (max-width: 480px) {
    padding: 2rem 1rem;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 95vh;
  }
}

.modal-mask {
  z-index: 1001 !important;
}

.modal-content {
  @media screen and (min-width: 700px) {
    top: 5%;
  }
  @media screen and (max-width: 480px) {
    width: 100% !important;
    height: 95vh !important;
    max-height: 95vh !important;
    margin: 0;
    padding: 0;
  }
}

.header-modal {
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    margin: 0 0 0.5rem 0;
  }

  p {
    margin: 0;
  }

  @media screen and (max-width: 480px) {
    margin-bottom: 1.5rem;
  }
}

.form-signup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  @media screen and (max-width: 480px) {
    gap: 1rem;

    .form-item {
      width: 100%;

      input {
        width: 100%;

        &:focus {
          outline: none;
        }
      }
    }
  }
}

.form-check {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;

  @media screen and (max-width: 480px) {
    gap: 1rem;

    .form-item {
      margin-bottom: 0;
    }
  }
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;

  label {
    font-weight: 500;
    color: #333;
    font-size: 14px;
    margin-bottom: 0;
    line-height: 0.8rem;
    padding-top: 3px;
  }

  input {
    padding: 10px 12px;
    border: 1px solid #7070704E;
    font-size: 14px;
    font-family: 'Raleway', sans-serif;
    transition: border-color 0.3s ease;

    &:focus {
      outline: none;
      border-color: #3B6152;
    }

    &::placeholder {
      color: #999;
    }
  }

  &.newsletter {
    flex-direction: row;
    align-items: flex-start;
    gap: 0.75rem;

    input {
      margin-top: 2px;
      width: auto;
    }

    label {
      margin: 0;
      line-height: 1.5;
    }

    .link-hortense {
      color: #3B6152;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: #2d4a3d;
      }
    }
  }
}

.login-link {
  text-align: center;
  margin-top: 1rem;

  p {
    margin: 0 0 0.5rem 0;
    color: #666;
    font-size: 14px;
  }

  .link-hortense {
    color: #3B6152;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      color: #2d4a3d;
    }
  }

  @media screen and (max-width: 480px) {
    margin-top: 1rem;
    padding-top: 1rem;
  }
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.modal-content {
  background: #F4F4F4 0% 0% no-repeat padding-box;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 1009px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}

.link-hortense {
  color: #3B6152;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    text-decoration: underline;
  }
}

.img-form-signup {
  width: 382px;
  height: 323px;
  object-fit: cover;
  border-radius: 10px;

  @media screen and (max-width: 480px) {
    width: 100%;
    height: 323px;
  }
}
</style>
